import vendor from "fragments/vendors/vendor"
import { gql } from "graphql-tag"

const GET_VENDOR_BY_ID = gql`
  ${vendor}

  query getVendorById($id: ID!) {
    getVendorById(id: $id) {
      ...Vendor
    }
  }
`

export default GET_VENDOR_BY_ID
